import React from 'react';
import PropTypes from 'prop-types';

import styles from './Display.scss';

const Display = ({ children }) => (
  <div className={styles.Display}>
    {children}
    <div className={styles['display-shadow']} />
  </div>
);

Display.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.node
  ]).isRequired
};

export default Display;



// WEBPACK FOOTER //
// ./src/containers/Display/Display.js